<template>
    <div class="page page__list">
      <search-bar
        @search="onSearch"
        name="jo_bkname,jo_explanation,jo_custname,jo_vendname"
        placeholder="输入账户、摘要等查找"
        ref="searchBar"
      />
      <filter-bar @change="onSearch" :filters="filters" ref="filterBar" />
      <scroll-list @refresh="onSearch" @loadpage="onSearchNext">
        <router-link
          class="weui-cell weui-cell_access"
          v-for="item in items"
          :key="item.id"
          :to="'/finance/journal/'+item.id"
        >
          <div class="weui-cell__bd">
            <p>{{item.jo_code}}</p>
            <p class="list-item-muted">{{item.jo_bkname}}</p>
          </div>
          <div class="weui-cell__ft">
            <p :class="item.jo_doubledebit>0?'text-success':'text-error'">{{ numberFormat(item.jo_doubledebit - item.jo_doublecredit, '#,##0.##') }}&nbsp;{{item.jo_currency}}</p>
            <p class="list-item-muted">{{item.jo_explanation}}</p>
          </div>
        </router-link>
      </scroll-list>
      <div class="list-footer">
        <label class="list-footer__label">合计：{{items.length}}条</label>
      </div>
    </div>
  </template>
  
  <script>
  import SearchBar from "@/components/SearchBar.vue";
  import FilterBar from "@/components/FilterBar.vue";
  import ScrollList from "@/components/ScrollList.vue";
  import list from "@/mixins/list.js";
  
  export default {
    components: {
      SearchBar,
      FilterBar,
      ScrollList
    },
    mixins: [list],
    data() {
      return {
        listUrl: "/api/finance/journal/all/list",
        filters: [
          {
            type: "date",
            name: "jo_date"
          },
          {
            type: "condition",
            label: "收支",
            options: [
              {
                label: "全部"
              },
              {
                value: 1,
                label: "收入",
                condition: "jo_doubledebit>0"
              },
              {
                value: 2,
                label: "支出",
                condition: "jo_doublecredit>0"
              }
            ]
          },
          {
            name: "jo_source",
            label: "来源",
            options: [
              {
                label: "全部"
              },
              {
                value: "付款申请单",
                label: "付款申请"
              },
              {
                value: "费用报销",
                label: "费用报销"
              },
              {
                value: "借款申请",
                label: "借款申请"
              },
              {
                value: "退款申请单",
                label: "退款申请"
              },
              {
                value: "应付退款单",
                label: "应付退款"
              },
              {
                value: "日记账转存",
                label: "转存"
              },
              {
                value: "应收票据异动",
                label: "应收票据"
              },
              {
                value: "工资表",
                label: "工资表"
              }
            ]
          }
        ]
      };
    }
  };
  </script>